"use client";

import { c as _c } from "react/compiler-runtime";
import HospitalResultCard from "@/shared/ui/molecules/HospitalResultCard";
export interface SearchResultHospitalCardProps {
  name: string;
  address: string;
  treatmentName?: string;
  score: number;
  reviewCount: number;
  thumbnailUrl?: string;
}
const SearchResultHospitalCard = t0 => {
  const $ = _c(7);
  const {
    name,
    address,
    treatmentName,
    score,
    reviewCount,
    thumbnailUrl
  } = t0;
  let t1;
  if ($[0] !== address || $[1] !== name || $[2] !== reviewCount || $[3] !== score || $[4] !== thumbnailUrl || $[5] !== treatmentName) {
    t1 = <HospitalResultCard name={name} address={address} categoryLabel={treatmentName} score={score} reviewCount={reviewCount} imageUrl={thumbnailUrl} />;
    $[0] = address;
    $[1] = name;
    $[2] = reviewCount;
    $[3] = score;
    $[4] = thumbnailUrl;
    $[5] = treatmentName;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};
export default SearchResultHospitalCard;